<template>
  <div class="finish-enter" :style="{height: viewportHeight}">
    <HomeHeader scroll-top="300"></HomeHeader>
    <div class="flex-column container w-wrapper">
      <div class="flex-column main">
        <div class="title">企业MCN机构申请</div>
        <div class="steps-box">
          <el-steps :active="5" align-center>
            <el-step title="选择公会类型"></el-step>
            <el-step title="填写公会信息"></el-step>
            <el-step title="填写资质信息"></el-step>
            <el-step title="确认信息"></el-step>
            <el-step title="等待审核"></el-step>
            <el-step title="完成入驻"></el-step>
          </el-steps>
        </div>
        <div class="flex-column-center form-box">
          <img class="img-status" src="@/assets/apply/submit-success.png" alt="">
          <div v-if="applyDetail.status === 4" style="color: #f56c6c;" class="title-status">您的申请已被驳回</div>
          <div v-else class="title-status">完成入驻</div>
          <div v-if="applyDetail.status === 4" class="dec">驳回原因：{{ applyDetail.reason }}</div>
          <div v-else class="dec">资料审核通过，您成功入驻火乐园MCN</div>
          <div class="flex-row-h-center edit-btn">
            <div class="mr20" v-if="applyDetail.status === 4">
              <el-button type="default" @click="onChangeInfo()">修改资料</el-button>
            </div>
            <div v-else>
              <el-button type="primary" @click="onLoginOrg()">前往登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {getItem} from "@/utils/storage";
import {joinApplyProgress} from "@/apis/audit";

export default {
  name: "select-type",
  components: {
    HomeHeader
  },
  data() {
    return {
      applyId: {}, // 申请ID
      applyDetail: {}, // 申请详情
      viewportHeight: '100vh',
      imgCodeUrl: '', // 图形验证码
      imgKey: '' // 图形验证码的key
    }
  },
  created() {
    this.joinApplyProgressApi()
  },
  mounted() {
    let viewportHeight = document.documentElement.clientHeight;
    this.viewportHeight = viewportHeight + 'px'
  },
  methods: {
    // 获取入驻进度
    joinApplyProgressApi() {
      const applyId = getItem('applyId')
      if (!applyId) {
        return
      }
      this.applyId = applyId
      joinApplyProgress({applyId: this.applyId}).then(res => {
        const data = res.data || {}
        this.applyDetail = data
      })
    },
    // 去修改资料
    onChangeInfo() {
      this.$router.push({
        path: '/apply/select',
        query: {applyId: this.applyId}
      })
    },
    // 跳转到公会端
    onLoginOrg() {
      if (this.applyDetail.isSetSecret) {
        const VUE_APP_ORG_URL = process.env.VUE_APP_ORG_URL
        window.open(VUE_APP_ORG_URL, '_blank')
      } else {
        // 跳转设置密码页面
        this.$router.push({
          path: '/forget',
          query: {applyId: this.applyId}
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.finish-enter {
  position: relative;
  overflow: hidden;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}

.container {
  margin: 60px auto 0;
  height: calc(100% - 100px);

  .back {
    padding: 16px 16px 16px 0;
    width: max-content;
    font-size: 16px;
    cursor: pointer;
  }

  .main {
    overflow-y: hidden;
    flex: 1;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 20px;
    border-radius: 4px;
    background-color: #ffffff;

    .steps-box {
      width: 800px;
      margin: 0 auto;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      width: 1000px;
      margin: 20px auto 0;
      padding: 120px 20px 20px;

      .img-status {
        width: 130px;
        height: 130px;
      }

      .title-status {
        margin-top: 24px;
        font-size: 20px;
        font-weight: bold;
      }

      .dec {
        font-size: 14px;
        margin-top: 16px;
      }

      .edit-btn {
        margin-top: 24px;
      }
    }

    .title {
      margin-bottom: 30px;
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }

    .type-item {
      margin: 20px 0;
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #409EFF;
      }
    }
  }
}
</style>